import { TextDef } from './text'
import { NumberDef } from './number'
import { TextareaDef } from './textarea'
import { SelectDef } from './select'
import { CascaderDef } from './cascader'
import { RadioDef } from './radio'
import { CheckboxDef } from './checkbox'
import { DateDef } from './date'
import { TimeDef } from './time'
import { PlainDef } from './plain'
import { UploadDef } from './upload'
import { TableDef } from './table'
import { CustomDef } from './custom'
import { FileLinkDef } from './file-link'

export * from './text'
export * from './number'
export * from './textarea'
export * from './select'
export * from './cascader'
export * from './radio'
export * from './checkbox'
export * from './date'
export * from './time'
export * from './plain'
export * from './upload'
export * from './custom'
export * from './table'
export * from './file-link'

export type FieldDef = TextDef
  | NumberDef
  | TextareaDef
  | SelectDef
  | CascaderDef
  | RadioDef
  | CheckboxDef
  | DateDef
  | TimeDef
  | PlainDef
  | UploadDef
  | TableDef
  | CustomDef
  | FileLinkDef
